@if ({}; as STATE) {
  <section class="competing-time-slots-layout"></section>
}
